<template>
  <v-dialog
    v-model="dialog"
    width="600"
    scrollable
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" dark v-bind="attrs" v-on="on">
        Contact form
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="primary" dense>
        <v-toolbar-title>Company contact form</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text color="white" @click="send()"
            >Submit</v-btn
          >

          <v-btn text color="white" @click="clearAndClose()"
            >Discard</v-btn
          ></v-toolbar-items
        >
      </v-toolbar>
      <v-card-text class="pt-8">
        <v-row>
          <v-col>
            <v-alert
                dismissible
                color="red"
                text
                :value="message.length > 0"
            >{{message}}</v-alert>
            <v-form
                ref="contactForm"
                lazy-validation
                >
              <v-text-field
                required
                v-model="formData.name"
                label="Name *"
                :rules="rules.notEmptyRules"
                outlined
              ></v-text-field>
              <v-text-field
                required
                v-model="formData.organization"
                label="Organization"
                outlined
              ></v-text-field>
              <v-text-field
                required
                v-model="formData.email"
                label="Email *"
                :rules="rules.emailRules"
                outlined
              ></v-text-field>
              <v-text-field
                required
                v-model="formData.phone"
                label="Phone"
                outlined
              ></v-text-field>
              <v-textarea
                required
                v-model="formData.message"
                label="Message *"
                :rules="rules.notEmptyRules"
                outlined
              ></v-textarea>
            </v-form>
            <p>Business Finland values and respects your privacy and personal information. 
              We process your personal information in accordance with applicable laws and
              regulations. You will find a more detailed description of the processing of
              personal data in our <router-link :to="getRouteTo('privacy notice')">Privacy Notice</router-link>.</p>
            <p><small>* Required field</small></p>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>

export default {
    data(){
        return {
            dialog: false,
            message: '',
            formData: {
                type: 'employer'
            },
            rules: {
                notEmptyRules: [
                    v => !!v || 'Please fill out this field'
                ],
                emailRules: [
                    v => !!v || 'Please fill out this field',
                    v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
                ]
            }
        }
    },
    methods: {
        send(){
            // Validate form
            let valid = this.$refs.contactForm.validate();
            if(valid){
                this.message = '';
                // Send form
                this.$store.dispatch('dispatchPostContactForm', { formData: this.formData }).then((res) => {
                    this.clearAndClose();
                    this.$store.dispatch("commitSnackbar", { show: true, message: "Message sent succesfully.", timeout: 4000, color: "primary" });
                });
            }
            else{
                this.message = 'Please fill the required fields in a valid format.';
            }
        },
        clearAndClose(){
            this.formData = {};
            this.dialog = false;
        },
        getRouteTo(keyword){
          let page = this.$store.state.pages.find((page) => page.navTitle.toLowerCase().includes(keyword));
          return '/' + page !== undefined ? page.navTitle.toLowerCase().replaceAll(' ', '-') : '';
        }
    }
}

</script>
<style></style>